import { HibaUzenet } from '../ui/elemek.tsx';
import { hibajegyHibaSzoveg } from './api.ts';
import { HIBAJEGY_STATUSZ_CIMKE, PRIORITAS_CIMKE, type HibajegyPrioritas, type HibajegyStatusz } from './tipusok.ts';

const STATUSZ_SZIN: Record<HibajegyStatusz, string> = {
  bekuldve: 'text-kiemelt',
  javitas_alatt: 'text-masodlagos',
  kesz: 'text-siker',
  elutasitva: 'text-szoveg-halk',
  uj_fejlesztes: 'text-sav-kozep',
};

/** Állapotjelző: színes pont és magyar szöveg (a leadek állapotjelzőjével azonos kinézet). */
export function HibajegyStatuszCimke({ statusz }: { statusz: HibajegyStatusz }) {
  return (
    <span className={`inline-flex items-center gap-1.5 whitespace-nowrap text-sm ${STATUSZ_SZIN[statusz]}`}>
      <span aria-hidden className="size-[7px] rounded-full bg-current" />
      {HIBAJEGY_STATUSZ_CIMKE[statusz]}
    </span>
  );
}

const PRIORITAS_SZIN: Record<HibajegyPrioritas, string> = { raer: 'text-szoveg-halk', normal: 'text-szoveg', surgos: 'text-hiba font-medium' };

export function PrioritasCimke({ prioritas }: { prioritas: HibajegyPrioritas }) {
  return <span className={`whitespace-nowrap text-sm ${PRIORITAS_SZIN[prioritas]}`}>{PRIORITAS_CIMKE[prioritas]}</span>;
}

/** Hibajegy-műveletek hibája: a saját kódok magyar szövege, a többit a közös hibaüzenet fordítja. */
export function HibajegyHiba({ hiba }: { hiba: unknown }) {
  if (!hiba) return null;
  const szoveg = hibajegyHibaSzoveg(hiba);
  if (szoveg) return <p role="alert" className="rounded-xl border border-hiba bg-hiba-hatter px-3.5 py-2.5 text-sm text-hiba">{szoveg}</p>;
  return <HibaUzenet hiba={hiba} />;
}
